module.exports = __webpack_public_path__ + "static/media/1.78bc70e4.png";